module.exports = __webpack_public_path__ + "static/media/francesca-profile-02.6b7b2752.jpg";